//imports
import {
    UNITTYPE_EVENT_CREATE_EDIT_OPEN_MODAL,
    UNITTYPE_EVENT_CREATE_REQUEST,
    UNITTYPE_EVENT_CREATE_RESULT,
    UNITTYPE_EVENT_EDIT_REQUEST,
    UNITTYPE_EVENT_EDIT_RESULT,
    UNITTYPE_EVENT_GET_REQUEST,
    UNITTYPE_EVENT_GET_RESULT,
    UNITTYPE_EVENT_GET_UNIT_TYPES_REQUEST,
    UNITTYPE_EVENT_GET_UNIT_TYPES_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    createUnitTypeEvent: null,
    updateUnitTypeEvent: null,
    unitEventType: null,
    currentUnitTypeEvent: null,
    unitTypes: null
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UNITTYPE_EVENT_GET_REQUEST:
            return { ...state, loading: true }

        case UNITTYPE_EVENT_GET_RESULT:
            return { ...state, loading: false, unitEventType: action.payload }

        case UNITTYPE_EVENT_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, currentUnitTypeEvent: action.payload.unitTypeEvent }

        case UNITTYPE_EVENT_CREATE_REQUEST:
            return { ...state, loading: true }

        case UNITTYPE_EVENT_CREATE_RESULT:
            return { ...state, loading: false, createUnitTypeEvent: action.payload }

        case UNITTYPE_EVENT_EDIT_REQUEST:
            return { ...state, loading: true }

        case UNITTYPE_EVENT_EDIT_RESULT:
            return { ...state, loading: false, updateUnitTypeEvent: action.payload }

        case UNITTYPE_EVENT_GET_UNIT_TYPES_REQUEST:
            return { ...state, loading: true }

        case UNITTYPE_EVENT_GET_UNIT_TYPES_RESULT:
            return { ...state, loading: false, unitTypes: action.payload }

        case CLEAR_REDUX:
            return ["", "UNITTYPE_EVENT_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};